module.exports = __webpack_public_path__ + "img/CF_2BB.9df98a11.jpg";